import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ADR_REVIEW } from "../../../_constants/actionConstants";
import { adrSections } from "../../../_constants/docSections";
import { getWpPrefix, getWpNumber } from "../utils/adrUtilsV3";
import { MAX_COLUMNS } from "../utils/adrUtilsV3";
import { AdrReviewWpDescHelpV3 } from "./AdrReviewWpDescHelpV3";
import { AdrCorrectionCommentsV3 } from "./AdrCorrectionCommentsV3";
import { useMemo } from "react";

export function AdrReviewEquipmentSetV3(props) {
  const { tabId, wpSortOrder } = props;
  const adr = useSelector((state) => state.adr.openAdrs[tabId] || null);
  const projContractorList = useSelector(
    (state) => state.contractors.projContractorLists[adr.projectId] || null
  );
  const projEquipList = useSelector(
    (state) => state.equipment.projEquipLists[adr.projectId] || null
  );
  const projLaborList = useSelector(
    (state) => state.labors.projLaborLists[adr.projectId] || null
  );
  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.pendingIssues.projPendingIssueLists[adr.projectId] || null
  );

  const [showWpHelp, toggleWpHelp] = useState(false);

  const filteredCcs = adr
    ? (adr.correctionComments || []).filter(
        (cc) => cc.section === adrSections.ADR_SECTION_EQUIPMENT
      )
    : [];

  const hasCorrectionComment = (fieldInfoToLookup) => {
    const ccBase = adr.correctionComments.filter(
      (cc) =>
        cc.section === adrSections.ADR_SECTION_EQUIPMENT &&
        cc.fieldInfo &&
        cc.fieldInfo.equipmentId === fieldInfoToLookup.equipmentId
    );
    const cc = ccBase.find((c) =>
      ["regHours", "otHours"].includes(fieldInfoToLookup.name)
        ? c.fieldInfo.workPerformedId === fieldInfoToLookup.workPerformedId &&
          c.fieldInfo.name === fieldInfoToLookup.name
        : c.fieldInfo.name === fieldInfoToLookup.name
    );
    return cc ? true : false;
  };

  const renderEquipmentThead = () => {
    const wpLength = (wpSortOrder || []).length;
    let th = [];
    let i = 0;
    for (i = 0; i < wpLength; i++) {
      th.push(
        <th
          key={`eqWpThKey_${i}`}
          className="th-equip-hours review align-bottom border-right"
          // onClick={props.toggleWpDescHelp_eq}
        >
          {adr.workPerformedClient[wpSortOrder[i].wpTabId].isIdle && (
            <React.Fragment>
              <small>
                <span className="text-danger"> (idle)</span>
              </small>
              <br />
            </React.Fragment>
          )}
          <small>{getWpPrefix(adr.workPerformedClient[wpSortOrder[i].wpTabId])}</small>{" "}
          {getWpNumber(
            adr.workPerformedClient[wpSortOrder[i].wpTabId],
            projItemList,
            projCcoList,
            projPendingIssueList
          )}
        </th>
      );
    }
    if (i < MAX_COLUMNS) {
      for (let remCol = i; remCol < MAX_COLUMNS; remCol++) {
        th.push(
          <th
            key={`eqWpThKey_${remCol}`}
            className="th-equip-hours review border-right"
          />
        );
      }
    }
    return (
      <thead>
        <tr className="bg-lightgray">
          <th className="th-equip-contractor review align-bottom border-right">
            Contractor
          </th>
          <th className="th-equip-number-desc review align-bottom border-right">
            Number/Desc.
          </th>
          <th className="td-equip-time-type review border-right" />
          {th}
          <th className="th-equip-remarks review align-bottom">Remarks</th>
        </tr>
      </thead>
    );
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-9">
          <h5 className="text-muted">Equipment</h5>
        </div>
        <div className="col-3 border-left"></div>
      </div>
      {showWpHelp && (
        <AdrReviewWpDescHelpV3
          toggleWpHelp={toggleWpHelp}
          showWpHelp={showWpHelp}
          {...props}
        />
      )}
      <div className="row">
        <div className="col-lg-9">
          {adr &&
          Object.values(adr.equipmentSetClient).filter(
            (e) => e.contractorId && e.equipmentId
          ).length === 0 ? (
            <div className="row">
              <div className="col-12">No equipment to report this day.</div>
            </div>
          ) : (
            <table className="table-equip review border-top border-bottom">
              {renderEquipmentThead()}
              <tbody>
                {adr.equipmentSetOrder.map((esrKey) => {
                  const esr = adr.equipmentSetClient[esrKey] || null;
                  if (esr && esr.contractorId && esr.equipmentId) {
                    const hasOt = Object.values(esr.equipmentHours).some(
                      (eh) => eh.otHours > 0
                    );
                    return (
                      <React.Fragment key={`equipWpOtFragKey_${esrKey}`}>
                        <AdrReviewEquipmentSetRowV3
                          {...props}
                          esrKey={esrKey}
                          hasOt={hasOt}
                          adr={adr}
                          wpSortOrder={wpSortOrder || []}
                          projContractorList={projContractorList}
                          projEquipList={projEquipList}
                          projLaborList={projLaborList}
                          hasCorrectionComment={hasCorrectionComment}
                        />
                        {hasOt && (
                          <AdrReviewEquipmentSetOtRowV3
                            {...props}
                            esrKey={esrKey}
                            adr={adr}
                            projEquipList={projEquipList}
                            wpSortOrder={wpSortOrder || []}
                            hasCorrectionComment={hasCorrectionComment}
                          />
                        )}
                      </React.Fragment>
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="col-lg-3 col-md-12 border-left">
          <AdrCorrectionCommentsV3
            section={adrSections.ADR_SECTION_EQUIPMENT}
            correctionComments={filteredCcs}
            tabId={tabId}
            {...props}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

function AdrReviewEquipmentSetRowV3(props) {
  const {
    tabId,
    esrKey,
    wpSortOrder,
    hasOt,
    adr,
    projContractorList,
    projEquipList,
    projLaborList,
    hasCorrectionComment,
    reviewerInitials,
    userIsReviewer,
  } = props;
  const dispatch = useDispatch();

  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.pendingIssues.projPendingIssueLists[adr.projectId] || null
  );
  const user = useSelector((state) => state.authentication.user || null);

  const handleClick_field = (fieldInfo) => (e) => {
    e.preventDefault();
    if (!hasCorrectionComment(fieldInfo) && adr.isInReview && userIsReviewer && user)
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.ADD_BLANK,
        tabId,
        byUserId: user.userId,
        section: adrSections.ADR_SECTION_EQUIPMENT,
        fieldInfo,
      });
  };

  const esr = adr.equipmentSetClient[esrKey];

  const contractor = useMemo(
    () =>
      (projContractorList || []).find((c) => c.contractorId === esr.contractorId) || null,
    [projContractorList]
  );
  const equipment = useMemo(
    () => (projEquipList || []).find((e) => e.equipmentId === esr.equipmentId) || null,
    [projEquipList]
  );
  const numberMakeDesc = equipment ? equipment.numberMakeDesc : "(no/desc N/A)";

  const metadata = {
    esrKey,
    equipmentId: esr.equipmentId,
    workPerformedId: null,
    reviewerInitials,
  };

  const numberDescInfo = {
    ...metadata,
    name: "numberMakeDesc",
    value: numberMakeDesc,
    label: "Number/Make/Desc",
    subLabel: `${numberMakeDesc}`,
  };

  const remarksInfo = {
    ...metadata,
    name: "equipmentRemarks",
    value: esr.remarks.remarks || "",
    label: "Equip. Remarks & Operators",
    subLabel: "",
  };

  let operatorList = []; // Collection of operator snippets (ex: BI#3 - John Smith)
  Object.entries(esr.equipmentHours).forEach(([wpTabId, eh]) => {
    if (eh.operatorId && projLaborList) {
      const operator = (projLaborList || []).find((l) => l.laborId === eh.operatorId);
      operatorList.push(
        <React.Fragment>
          <small>{getWpPrefix(adr.workPerformedClient[wpTabId])}</small>
          {`${getWpNumber(
            adr.workPerformedClient[wpTabId],
            projItemList,
            projCcoList,
            projPendingIssueList
          )} - ${operator ? operator.fullName : "(N/A)"}`}
        </React.Fragment>
      );
    }
  });

  let td = [];
  td.push(
    <td
      key={`equipContractorKey_${esrKey}`}
      className="td-equip-contractor review align-top border-right"
      rowSpan={hasOt ? "2" : "1"}
    >
      {contractor ? contractor.abbreviation : ""}
    </td>
  );
  td.push(
    <td
      key={`equipKey_${esrKey}`}
      className="td-equip-number-desc review align-top border-right"
      rowSpan={hasOt ? "2" : "1"}
    >
      <div
        className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
          hasCorrectionComment(numberDescInfo) ? "has-comment" : ""
        }`}
        onClick={handleClick_field(numberDescInfo)}
      >
        {numberMakeDesc}
      </div>
    </td>
  );
  td.push(
    <td
      key={`equipTimeTypeKey_${esrKey}`}
      className="td-equip-time-type review align-top border-right"
    >
      <small>
        <span className="badge badge-info my-auto">RT</span>
      </small>
    </td>
  );

  let i = 0;
  for (i = 0; i < wpSortOrder.length; i++) {
    const wp = adr.workPerformedClient[wpSortOrder[i].wpTabId];
    const hours = esr.equipmentHours[wpSortOrder[i].wpTabId].regHours || "0";
    const hourInfo = {
      ...metadata,
      workPerformedId: wp.workPerformedId,
      name: "regHours",
      value: hours,
      label: "Hours (RT)",
      subLabel: `${hours} for ${numberMakeDesc}, on ${getWpPrefix(wp)}${getWpNumber(
        wp,
        projItemList,
        projCcoList,
        projPendingIssueList
      )}`,
    };
    td.push(
      <td
        key={`eqWpHoursKey_${i}_${esrKey}`}
        className="td-equip-hours review text-right align-top border-right"
      >
        <div
          className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
            hasCorrectionComment(hourInfo) ? "has-comment" : ""
          }`}
          onClick={handleClick_field(hourInfo)}
        >
          {hours}
        </div>
      </td>
    );
  }
  if (i < MAX_COLUMNS) {
    for (let remCol = i; remCol < MAX_COLUMNS; remCol++) {
      td.push(
        <td
          key={`eqWpHoursKey_${remCol}_${esrKey}`}
          className="td-equip-hours review text-right align-top border-right"
        />
      );
    }
  }
  td.push(
    <td
      key={`eqBlankColKey_${esrKey}`}
      className="td-equip-remarks review align-top"
      rowSpan={hasOt ? "2" : "1"}
    >
      <div
        className={`${
          operatorList.length > 0 || esr.remarks.remarks
            ? `${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
                hasCorrectionComment(remarksInfo) ? "has-comment" : ""
              }`
            : ""
        }`}
        onClick={handleClick_field(remarksInfo)}
      >
        {operatorList.length === 0 ? (
          esr.remarks.remarks
        ) : (
          <React.Fragment>
            {esr.remarks.remarks}
            <br />
            <em>Operators:</em>
            <br />
            {operatorList.map((o, index) => (
              <React.Fragment key={`equipOpDispKey_${index}`}>
                <span>{o}</span>
                <br />
              </React.Fragment>
            ))}
          </React.Fragment>
        )}
      </div>
    </td>
  );
  return (
    <tr className="border-top" key={`esrTrKey_${esrKey}`}>
      {td}
    </tr>
  );
}

function AdrReviewEquipmentSetOtRowV3(props) {
  const {
    tabId,
    esrKey,
    wpSortOrder,
    adr,
    projEquipList,
    hasCorrectionComment,
    reviewerInitials,
    userIsReviewer,
  } = props;
  const dispatch = useDispatch();
  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.pendingIssues.projPendingIssueLists[adr.projectId] || null
  );
  const user = useSelector((state) => state.authentication.user || null);

  const esr = adr.equipmentSetClient[esrKey];

  const equipment = useMemo(
    () => (projEquipList || []).find((e) => e.equipmentId === esr.equipmentId) || null,
    [projEquipList, esr]
  );
  const numberMakeDesc = equipment ? equipment.numberMakeDesc : "(no/desc N/A)";

  const metadata = {
    esrKey,
    equipmentId: esr.equipmentId,
    workPerformedId: null,
    reviewerInitials,
  };

  const handleClick_field = (fieldInfo) => (e) => {
    e.preventDefault();
    if (!hasCorrectionComment(fieldInfo) && adr.isInReview && userIsReviewer && user)
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.ADD_BLANK,
        tabId,
        byUserId: user.userId,
        section: adrSections.ADR_SECTION_EQUIPMENT,
        fieldInfo,
      });
  };

  let td = [];
  td.push(
    <td
      key={`equipOtTimeTypeKey_${esrKey}`}
      className="td-equip-time-type review align-top border-right"
    >
      <small>
        <span className="badge badge-warning my-auto">OT</span>
      </small>
    </td>
  );
  let i = 0;
  for (i = 0; i < wpSortOrder.length; i++) {
    const wp = adr.workPerformedClient[wpSortOrder[i].wpTabId];
    const hours = esr.equipmentHours[wpSortOrder[i].wpTabId].otHours || "0";
    const hourInfo = {
      ...metadata,
      workPerformedId: wp.workPerformedId,
      name: "otHours",
      value: hours,
      label: "Hours (OT)",
      subLabel: `${hours} for ${numberMakeDesc}, on ${getWpPrefix(wp)}${getWpNumber(
        wp,
        projItemList,
        projCcoList,
        projPendingIssueList
      )}`,
    };
    td.push(
      <td
        key={`eqWpOtHoursKey_${i}_${esrKey}`}
        className="td-equip-hours review text-right align-top border-right"
      >
        <div
          className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
            hasCorrectionComment(hourInfo) ? "has-comment" : ""
          }`}
          onClick={handleClick_field(hourInfo)}
        >
          {hours}
        </div>
      </td>
    );
  }
  if (i < MAX_COLUMNS) {
    for (let remCol = i; remCol < MAX_COLUMNS; remCol++) {
      td.push(
        <td
          key={`eqWpOtHoursKey_${remCol}_${esrKey}`}
          className="td-equip-hours review text-right align-top border-right"
        />
      );
    }
  }
  return (
    <tr className="border-top" key={`esrOtKey_${esrKey}`}>
      {td}
    </tr>
  );
}
